import React from "react";
import "./Workshops.css";
import { Flex, Header, SafeArea } from "../../components/layout";
import { Image } from "../../components/ui";

import ImageBienEtre from "../../assets/images/workshop/bien-etre.webp";
import ImageCoaching from "../../assets/images/workshop/coaching.png";
import ImageExperimentation from "../../assets/images/workshop/experimentation-terrain.webp";
import { Link } from "react-router-dom";

function Workshops() {
  return (
    <SafeArea className="Workshops">
      <Flex type="col-center" gap={80}>
        <Header
          level="h3"
          title="Les Ateliers"
          text="Dans le cadre de nos stages, venez découvrir les différents ateliers animés par des professionnels confirmés"
        />
        <Flex type="center-start" gap={40} wrap className="list">
          <Flex type="col-center" gap={30}>
            <Link to="/ateliers/bien-etre">Bien-être</Link>
            <Image src={ImageBienEtre} alt="Bien-être" />
          </Flex>
          <Flex type="col-center" gap={30}>
            <Link to="/ateliers/coaching">Coaching</Link>
            <Image src={ImageCoaching} alt="Coaching" />
          </Flex>
          <Flex type="col-center" gap={30}>
            <Link to="/ateliers/experimentations-sur-le-terrain">
              Expérimentations sur le terrain
            </Link>
            <Image
              src={ImageExperimentation}
              alt="Experimentation sur le terrain"
            />
          </Flex>
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default Workshops;
